import {DefaultPrinterConfigurationDto, PrinterTypeDto} from "../../api/ums";
import {makeAutoObservable} from "mobx";
import {api} from "../../api";


class UserPrinterPreferenceStore {

    private get userPrinters(): DefaultPrinterConfigurationDto[] {
        return this._userPrinters;
    }

    get vlogPrinterId(): string | undefined {
        return this._userPrinters.find(p => p.printerType === PrinterTypeDto.VLOG)?.printerId;
    }

    get zebraPrinterId(): string | undefined {
        return this._userPrinters.find(p => p.printerType === PrinterTypeDto.ZEBRA)?.printerId;
    }

    get documentPrinterId(): string | undefined {
        return this._userPrinters.find(p => p.printerType === PrinterTypeDto.DOCUMENT)?.printerId;
    }

    private set userPrinters(value: DefaultPrinterConfigurationDto[]) {
        this._userPrinters = value;
    }

    private _userPrinters: DefaultPrinterConfigurationDto[] = []


    constructor() {
        makeAutoObservable(this)
    }

    async load() {
        try {
            const result = await api.ums.api.getConfiguration()

            if (result?.data) {
                this.userPrinters = result?.data.defaultPrinters!
            }
        } catch (error) {
            console.error(error);
        }
    }

    reset() {
        this.userPrinters = []
    }
}

const userPrinterPreferenceStore = new UserPrinterPreferenceStore()

export {
    userPrinterPreferenceStore
}
